export default __webpack_public_path__ + "static/media/dove.c392a532.png";